const labelProducts = {
  PATIENT_GUIDE: "Guia para pacientes",
  BASIC: "Básico",
  ADVANCED: "Avançado",
  PREMIUM: "Premium",
};

export default labelProducts;
